<template>
  <button
    type="button"
    class="nav-link selected-items-tab"
    :class="{ active, highlight: count > 0 }"
    :aria-pressed="active"
    :aria-label="`Selected items: ${count}`"
    @click="$emit('click', $event)"
  >
    <i class="la la-check-circle selected-tab-icon" aria-hidden="true"></i>
    <span>Selected</span>
    <span v-if="count > 0" class="bucket-size" aria-live="polite" aria-atomic="true">{{ count }}</span>
  </button>
</template>

<script>
export default {
  name: 'SelectedItemsTab',
  props: {
    count: { type: Number, default: 0 },
    active: { type: Boolean, default: false },
  },
  emits: ['click'],
};
</script>
